export class SameRootStringInfo {
  constructor(
    public sameRoot: boolean,
    public shortest: string,
    public longest: string,
    public comparsion: number) {};
}

export class StringTools {

  public static checkSameRoot(strA: string, strB: string): SameRootStringInfo {
    let shortestStr;
    let longestStr;
    let comparsion = 0;

    if (strA.length > strB.length) {
      shortestStr = strB;
      longestStr = strA;
      comparsion = 1;

    }
    else {
      shortestStr = strA;
      longestStr = strB;
      comparsion = -1;
    }

    return {
      sameRoot: longestStr.indexOf(shortestStr) === 0,
      shortest: shortestStr,
      longest: longestStr,
      comparsion: comparsion
    }
  }

  /**
   * Sort string making first the string has same root to other but its shorter.
   */
  public static sortStringShortestRootPriorityFn(nameA: string, nameB: string) {
    let rc: number;
    // If are the same but one is longer (for example 'Recurve Women' and
    // 'Recurve Women Team' shortest should be first.
    let sameRootInfo = StringTools.checkSameRoot(nameA, nameB);

    if (sameRootInfo.sameRoot) {
      rc = sameRootInfo.comparsion;
    }
    else {
      rc = (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
    }

    return rc;
  }

  /* Basic transliteration helper */
  public static transliterate(str: string): string {
    return str.replace(/[ÀÁÂÃÄÅ]/g, 'A')
      .replace(/[Æ]/g, 'AE')
      .replace(/[Ç]/g, 'C')
      .replace(/[ÈÉÊË]/g, 'E')
      .replace(/[ÌÍÎÏ]/g, 'I')
      .replace(/[Ñ]/g, 'N')
      .replace(/[ÒÓÔÕÖ]/g, 'O')
      .replace(/[Œ]/g, 'OE')
      .replace(/[ÙÚÛÜ]/g, 'U')
      .replace(/[ÝŸ]/g, 'Y')
      .replace(/[àáâãäå]/g, 'a')
      .replace(/[æ]/g, 'ae')
      .replace(/[ç]/g, 'c')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[ñ]/g, 'n')
      .replace(/[òóôõö]/g, 'o')
      .replace(/[œ]/g, 'oe')
      .replace(/[ùúûü]/g, 'u')
      .replace(/[ýÿ]/g, 'y');
  }
}